import React from 'react';
import MainTitle from 'base/components/MainTitle';
import Header from 'base/components/Header';
import { SettingsIcon } from 'base/components/Icon';

const Admin = () => (
  <>
    <Header>
      <MainTitle>
        <SettingsIcon />
        {' '}
Admin
      </MainTitle>
    </Header>
  </>
);

export default Admin;
